import {
  IconNameEnum,
  useModuleBEM,
  usePackagesStyles,
} from "@b2bportal/core-themes";
import { CorePackagesComponent } from "@b2bportal/core-types";
import { PackageSearch, usePackageAvailabilitySearch } from "@tenant/packages";
import { Dialog, DialogContent, DialogTrigger, Icon } from "@tenant/ui";
import defaultStyles from "./PackageAvailabilitySearch.module.scss";

const COMPONENT_KEY = CorePackagesComponent.PackageAvailabilitySearch;

export const PackageAvailabilitySearch = () => {
  const styles = usePackagesStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const viewProps = usePackageAvailabilitySearch();
  return viewProps != null ? (
    <div className={block}>
      <Dialog {...viewProps.context.dialogProps.props} modal={false}>
        <DialogTrigger asChild>
          <div className={cn("search-dialog-button")}>
            <div className={cn("icon")}>
              <Icon iconName={IconNameEnum.search} />
            </div>
            <div className={cn("content")}>
              <div className={cn("search-button-label")}>
                {viewProps.text.locationData}
              </div>
              <div className={cn("search-button-value")}>
                {viewProps.text.searchSummary}
              </div>
            </div>
          </div>
        </DialogTrigger>
        <DialogContent fullScreen>
          <PackageSearch
            onSubmitAppend={viewProps.context.dialogProps.closeDialog}
          />
        </DialogContent>
      </Dialog>
      <PackageSearch className={cn("search-form")} />
    </div>
  ) : null;
};
